export const sortMembers = (project?: ProjectProjectEntity) =>
  project?.members
    .map((member) =>
      member.membership === 'owner'
        ? { member, order: 1 }
        : member.membership === 'admin'
        ? { member, order: 2 }
        : member.membership === 'member'
        ? { member, order: 3 }
        : member.membership === 'teacher'
        ? { member, order: 4 }
        : member.membership === 'extern'
        ? { member, order: 5 }
        : { member, order: 6 }
    )
    .sort((a, b) => a.order - b.order);
